import { createFileRoute } from '@tanstack/react-router';
import { SystemPage } from '@/features/system/SystemPage.tsx';

export const Route = createFileRoute('/_app/system')({
  component: SystemPage,
});
